import angular = require("angular");
import TPL = require("templates");

export class StepperDirective {

  template = TPL.commonDirectives.stepper;
  scope = {
    params: "=params"
  };

  static factory() {
    return () => new StepperDirective();
  }

}



/** WEBPACK FOOTER **
 ** ./src/scripts/directives/common/stepper.ts
 **/